import React, { useEffect } from "react";

const RazorpayView: React.FC = () => {
  useEffect(() => {
    // Load Razorpay script dynamically
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      openRazorpay();
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const openRazorpay = () => {
    const options = {
      key: "rzp_test_YourKeyHere", // Replace with your Razorpay Test or Live Key
      amount: 10000, // Amount in paise (10000 = ₹100)
      currency: "INR",
      name: "Your Company",
      description: "Payment for Order #123",
      image: "https://yourlogo.com/logo.png",
      handler: function (response: any) {
        alert("Payment Successful! Payment ID: " + response.razorpay_payment_id);
      },
      prefill: {
        name: "John Doe",
        email: "johndoe@example.com",
        contact: "9876543210",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const razorpay = new (window as any).Razorpay(options);
    razorpay.open();
  };

  return (
    <div>
      <h2>Razorpay Payment UI</h2>
      <button onClick={openRazorpay} style={{ padding: "10px 20px", fontSize: "16px", cursor: "pointer" }}>
        Pay Now
      </button>
    </div>
  );
};

export default RazorpayView;
